/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import makeMutationHook from 'core/types/makeMutationHook'
import makeQueryHook from 'core/types/makeQueryHook'
import * as operations from 'core/types/operations'

export const useInternalPaidOffSideEffectsPost = makeMutationHook(
  operations.internalPaidOffSideEffectsPost,
)

export const useInternalBorrowersList = makeQueryHook(
  operations.internalBorrowersList,
)

export const useInternalBorrowerCreate = makeMutationHook(
  operations.internalBorrowerCreate,
)

export const useAdminBorrowersReindex = makeMutationHook(
  operations.adminBorrowersReindex,
)

export const useInternalBorrowersListIds = makeQueryHook(
  operations.internalBorrowersListIds,
)

export const useInternalBorrowerGet = makeQueryHook(
  operations.internalBorrowerGet,
)

export const useInternalBorrowerUpdate = makeMutationHook(
  operations.internalBorrowerUpdate,
)

export const useAdminGetBorrowerIndex = makeQueryHook(
  operations.adminGetBorrowerIndex,
)

export const useAdminBorrowerReindex = makeMutationHook(
  operations.adminBorrowerReindex,
)

export const useInternalBorrowerSearch = makeQueryHook(
  operations.internalBorrowerSearch,
)

export const useBorrowersList = makeQueryHook(operations.borrowersList)

export const useBorrowerCreate = makeMutationHook(operations.borrowerCreate)

export const useBorrowerGet = makeQueryHook(operations.borrowerGet)

export const useBorrowerUpdate = makeMutationHook(operations.borrowerUpdate)

export const useBorrowerSearch = makeQueryHook(operations.borrowerSearch)

export const useInternalGetPrimaryIdentity = makeQueryHook(
  operations.internalGetPrimaryIdentity,
)

export const useInternalListIdentities = makeQueryHook(
  operations.internalListIdentities,
)

export const useInternalCreateIdentity = makeMutationHook(
  operations.internalCreateIdentity,
)

export const useInternalGetIdentity = makeQueryHook(
  operations.internalGetIdentity,
)

export const useInternalUpdateIdentity = makeMutationHook(
  operations.internalUpdateIdentity,
)

export const useInternalDeleteIdentity = makeMutationHook(
  operations.internalDeleteIdentity,
)

export const useGetPrimaryIdentity = makeQueryHook(
  operations.getPrimaryIdentity,
)

export const useListIdentities = makeQueryHook(operations.listIdentities)

export const useCreateIdentity = makeMutationHook(operations.createIdentity)

export const useGetIdentity = makeQueryHook(operations.getIdentity)

export const useUpdateIdentity = makeMutationHook(operations.updateIdentity)

export const useDeleteIdentity = makeMutationHook(operations.deleteIdentity)

export const useCanInteract = makeMutationHook(operations.canInteract)

export const useInternalCanInteract = makeMutationHook(
  operations.internalCanInteract,
)
